export function slugify(title) {
  return (title || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .substring(0, 80);
}

export function computeReadingMinutes(body) {
  if (!body) return 1;
  const words = body.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

export function isPostVisible(post) {
  if (!post) return false;
  if (post.status === "published") return true;
  if (post.status === "scheduled" && post.published_date) {
    return new Date(post.published_date) <= new Date();
  }
  return false;
}

export function formatDate(dateStr) {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function toDateTimeLocal(isoString) {
  if (!isoString) return "";
  const d = new Date(isoString);
  const offset = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - offset).toISOString().slice(0, 16);
}

export function fromDateTimeLocal(localString) {
  if (!localString) return null;
  return new Date(localString).toISOString();
}

export function relativeCountdown(dateStr) {
  if (!dateStr) return "";
  const diff = new Date(dateStr) - Date.now();
  if (diff <= 0) return "now";
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  if (days > 0) return `in ${days} day${days > 1 ? "s" : ""}`;
  if (hours > 0) return `in ${hours} hour${hours > 1 ? "s" : ""}`;
  const mins = Math.floor(diff / 60000);
  return `in ${mins} min`;
}